export enum GameType {
    FREE_ROLL,
    SIX_FORTY_NINE,
}